import { toCurrency } from 'shared/format-utils'

type BuildParams = {
  amount?: string
  isEditing: boolean
}

export function buildSaveMoneyByValuePageViewedPayload({ amount, isEditing }: BuildParams) {
  return {
    initial_amount: toCurrency(Number(amount ?? 0)),
    is_editing: isEditing
  }
}
